import type { FunctionComponent } from 'react';
import { useParams } from 'react-router';

import Throbber from 'components/Throbber';
import { AdminPage } from 'components/admin';
import AdminPractitionerProfile from 'components/admin/PractitionerProfile';

import { useArtist } from 'hooks';

import { useGlobalState } from 'utils';

import throbberTheme from 'themes/AppThrobber/black.scss';

import S from './style.scss';

const CmsPractitionerProfilePage: FunctionComponent = () => {
  const [perms] = useGlobalState('user.permissions');
  if (!perms) throw Error('Missing permissions');
  if (!perms.USER_MANAGEMENT) throw Error('Forbidden');

  const { id } = useParams();
  if (!id) throw Error('Missing practitioner ID');

  const practitioner = useArtist(id, { withAllUserDetails: true });
  const pUser = practitioner.data?.user;

  // TODO: If practitioner's intro video is uploaded, but not yet procesed,
  // we need to periodically reload its object (perhaps within the useArtist()
  // hook), and propagate its update (judging by the BEWARE comment below, it
  // should be updated to correctly capture reloaded practitioner data).
  // Though... not the top priority for now - the admin can just reload the
  // page manually, and we have a bunch other stuff to implement.

  return (
    <AdminPage
      contentClassName={S.container}
      subTitle={`Practitioners / ${pUser?.firstName ?? ''} ${pUser?.lastName ?? ''}`}
      title="Practitioner Profile"
    >
      {
        // BEWARE: Here <AdminPractitionerProfile> should be mounted only after
        // the practitioner data are loaded, otherwise it won't display them
        // correctly, as the current implementation copies given initial data
        // into the local component state, and does not refresh them if
        // practitioner value is changed.
        practitioner.data && !practitioner.loading
          ? <AdminPractitionerProfile practitioner={practitioner.data} />
          : <Throbber theme={throbberTheme} withDebounce withOverlay />
      }
    </AdminPage>
  );
};

export default CmsPractitionerProfilePage;
